// extracted by mini-css-extract-plugin
export default {"loading-spinner":"vd6B"};